<!-- 打印信息编辑弹窗---开始全是下拉框用了循环,后面需求变了..... -->
<template>
    <div class='information'>
        <el-dialog
            :title="ruleForm.filename"
            top="8vh"
            :visible.sync="dialogVisible"
            width="37%"
            @open = 'open'
            :before-close="cancel">
                <el-form :model="ruleForm" ref="ruleForm" label-width="100px">
                    <el-form-item 
                        :label="dictionaries[key]" 
                        :style="{display:(dictionaries[key]?'block':'none')}"
                        prop="region" 
                        v-for="(value,key,index) in option" 
                        :key="index">
                        <!-- 纸型, 颜色, 单双面, 纸张重量 -->
                        <el-select 
                            :disabled="key=='quality'" 
                            @change="changeS(key)" 
                            v-model="ruleForm[key]" 
                            v-if="key!='cover_color' && key!='binding_type' && key!='cover_type'">
                            <el-option
                                v-for="(values,key,indexs) in value"
                                :key="indexs"
                                :label="key"
                                :value="values"
                            ></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="封面:">
                        <!-- 封面 -->
                        <div 
                            class="image image2" >
                            <div
                                @click="imgclick(item.id , 'cover_type')" 
                                v-for="(item , index) in imgUrl['cover_type']" 
                                :key="index">                            
                                <img 
                                    :class="index == ruleForm['cover_type']? 'type-img-box':''" 
                                    :src="item.url" 
                                    alt="">
                                <span>{{item.name}}</span>
                            </div>
                        </div>
                    </el-form-item>

                    <!-- 皮纹纸颜色 -->
                    <el-form-item v-show="ruleForm.cover_type==1" label="皮纹纸颜色:">
                        <div class="radios" style="text-align: center;">
                            <div v-for="(values,key,indexs) in button" :key="indexs">
                                <img :src="imgs[values]" alt="">
                                <el-radio
                                v-model="ruleForm.radio"
                                :label="values">
                                {{key}}
                                </el-radio>
                            </div>
                        </div>
                    </el-form-item>

                    <!-- 当封面选择的不是无需封面显示以下部分 - 封面图片 -->
                    <el-form-item label="封面图片: " v-if="ruleForm['cover_type'] !=0">
                        <el-select v-model="ruleForm['cover']">
                            <el-option
                                v-for="(values,indexs) in cover"
                                :key="indexs"
                                :label="values.name"
                                :value="values.id"
                            ></el-option>
                        </el-select>
                        <!-- 当下拉框选中的是上传封面为自定义才显示 -->
                        <div class="coverBox" v-show="ruleForm['cover'] == 1"> 
                            <div>
                                <el-upload
                                    v-if="!ruleForm.coverS"
                                    class="upload coverImg"
                                    :show-file-list = "false"
                                    drag
                                    :headers="myHeaders"
                                    accept='.jpeg,.jpg,.png'
                                    :on-success = "(response, file, fileList)=>uploadSuccess(response, file, fileList,'my-upload1')"
                                    :on-error = "(err, file, fileList)=>uploadError(response, file, fileList,'my-upload1')"
                                    :action="getUploadOssInfoData.host || ''"
                                    :data='uploadData'
                                    :before-upload = "progress"
                                    ref="my-upload1">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                                <div class="del" v-if="ruleForm.coverS">
                                    <img :src="ruleForm.coverS" alt="">
                                    <div>
                                        <i class="el-icon-delete" v-on:click.stop="ruleForm.coverS = ''"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="coverImg2" v-show="!backCover">
                                <el-button @click="backCover = !backCover">
                                    添加封底
                                </el-button>
                                <p>封面与封底是一张图片则无需上传</p>
                            </div>
                            <div>
                                <el-upload
                                    v-if="!ruleForm.cover_backS"
                                    v-show="backCover"
                                    :show-file-list="false"
                                    class="upload coverImg coverImg3"
                                    drag
                                    :headers="myHeaders"
                                    accept='.jpeg,.jpg,.png'
                                    :on-success = "(response, file, fileList)=>uploadSuccess(response, file, fileList,'my-upload2')"
                                    :on-error = "(err, file, fileList)=>uploadError(response, file, fileList,'my-upload2')"
                                    :action="getUploadOssInfoData.host || ''"
                                    :data='uploadData'
                                    :before-upload = 'progress'
                                    ref="my-upload2">
                                    <i class="el-icon-plus"></i>
                                    <b v-on:click.stop="backCover = !backCover" class="el-icon-error"></b>
                                </el-upload>
                                <div class="del" v-if="ruleForm.cover_backS">
                                    <img :src="ruleForm.cover_backS" alt="">
                                    <div>
                                        <i class="el-icon-delete" v-on:click.stop="ruleForm.cover_backS = ''"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form-item>

                        <!-- 装订方式 -->
                    <el-form-item label="装订方式:">
                        <div 
                            class="image">
                            <div 
                                v-for="(item , index) in imgUrl['binding_type']" 
                                :key="index" 
                                v-show="ruleForm['cover_type'] !=0 || index!=4" 
                                @click="imgclick(item.id , 'binding_type')">
                                <img :src="item.url" alt="" :class="index == ruleForm['binding_type']? 'type-img-box':''">
                                <span>{{item.name}}</span>
                            </div>
                        </div> 
                    </el-form-item>
                </el-form>

                <!-- 打印份数 -->
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="copies">
                    <el-form-item label="份数: " prop="number">
                        <el-input class="inputnumber" v-model="ruleForm.number" placeholder="请输入打印份数"></el-input>
                        <div class="add">
                            <el-button 
                                :disabled="ruleForm.number<=1" 
                                @click="addISj('-')" 
                                type="text">
                                <i class="el-icon-minus"></i>
                            </el-button>
                            <el-button 
                                :disabled="ruleForm.number>=1000" 
                                @click="addISj('+')" 
                                type="text">
                                <i class="el-icon-plus"></i>
                            </el-button>
                        </div>
                    </el-form-item>
                </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="confirm('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        dialogVisible: {
          type: Boolean,
          required: false
        },
        oneData: {
            type: Object,
            required: {}
        }
    },
    watch: {
        "ruleForm.number": function(val){
            this.ruleForm.number = val.toString().replace(/\D/g, '')
        }
    },
    data () {
         // 打印份数表单验证
         const blurText = async(rule, value, callback) => {
           const boolean = new RegExp('^[1-9][0-9]*$').test(value)
               if (!boolean || value>1000) {
                callback(new Error('请输入一千以下的正整数'));
              }
         }
        return {
            loading: false, // 上传间隔
            imgs:{ // 皮纹纸颜色
                '1': require("../assets/img/2.jpg"),
                '2': require("../assets/img/5.jpg"),
                '3': require("../assets/img/6.jpg"),
                '4': require("../assets/img/7.jpg"),
                '5': require("../assets/img/8.jpg"),
                '6': require("../assets/img/9.jpg"),            
            },
            imgUrl:{ // 装订方式和封面
                binding_type: [
                    {
                        url: require("../assets/img/no-binding-1.jpg"),
                        name: '无需装订',
                        id: 0
                    },
                    {
                        url: require("../assets/img/dingshuding.jpg"),
                        name: '订书钉',
                        id: 1
                    },
                    {
                        url: require("../assets/img/piwenzhi.jpg"),
                        name: '骑马钉',
                        id: 2
                    },
                    {
                        url: require("../assets/img/tongbanzhi-1.jpg"),
                        name: '圈装',
                        id: 3
                    },
                    {
                        url: require("../assets/img/qmd.jpg"),
                        name: '胶装',
                        id: 4
                    },  
                ],
                cover_type: [
                    {
                        url: require("../assets/img/no-binding-1.jpg"),
                        name: '无需封面',
                        id: 0
                    },
                    {
                        url: require("../assets/img/piwenzhi2.jpg"),
                        name: '皮纹纸',
                        id: 1
                    },
                    {
                        url: require("../assets/img/tongbanzhi-2.jpg"),
                        name: '铜板纸',
                        id: 2
                    },
                ]
           },
            ruleForm: {
                number: 1
            },
            rules: {
                number: [
                    { required: true, message: '请输入份数', trigger: 'change' },
                    { validator: blurText, trigger: 'blur' }  //表单验证的时候会调用的方法
                ]
            },
            dictionaries: {
                size: '纸型: ',
                color: '颜色: ',
                side: '单双面: ',
                quality: '纸张重量: ',
            }, 
            option: {}, // 字典表查询的下拉框数据
            button: {},
            cover: [
                {
                    name: '自定义上传封面(最大50M)',
                    id:'1'
                },
                {
                    name: '默认文件首页尾页为封面',
                    id:'0'
                },
                {
                    name: '皮纹纸颜色为封面',
                    id:'2'
                }
            ],
            myHeaders: {
               Accept: 'application/json',
            },
            backCover: false, // 是否需要封底
            getUploadOssInfoData: '', // 直连参数
        };
    },
    created() {
        this.query()
        this.getUploadOssInfo()
    },
    computed:{
        uploadData:function() {
            return {
                name: '',
                key: '',
                policy: this.getUploadOssInfoData.policy,
                OSSAccessKeyId: this.getUploadOssInfoData.OSSAccessKeyId,
                success_action_status: 200,
                callback: this.getUploadOssInfoData.callback,
                signature: this.getUploadOssInfoData.signature,
            }
        }
    },
    methods: {
        // 获取直连参数
        async getUploadOssInfo() {
            var res = await this.Api.getUploadOssInfov()
            this.getUploadOssInfoData = res.data.data
        },
        // 上传封面部分事件
        progress(file) { // 上传文件1开始上传
            if (file.size > 256 * 1024 * 1024) {
                this.$message.error('文件超过256M，请压缩文件大小后上传');
                return false   //必须返回false
            }
            this.uploadData.name = file.name
            this.uploadData.key = this.getUploadOssInfoData.dir + file.name
        },
        // 上传成功
        async uploadSuccess(response, file, fileList,a) {
            this.$refs[a].clearFiles();
            if (response.code == -1) {
                this.uploadError(response.codeMsg)
                this.loading = false
                return
            }
            this.$message({
                message: '上传成功',
                type: 'success'
            });
            this.loading = false
            if(a == 'my-upload1') {
                this.ruleForm.coverS = response.data.download_url
            }else {
                this.ruleForm.cover_backS = response.data.download_url
            }
        },
        uploadError() {
            this.$message.error('上传失败');
        },
        // 选择打印黑白还是彩色, 对应黑白70g,, 彩色80g
        changeS(e) {
            if(e != 'color') return
            if(this.ruleForm['color'] == 1) {
                this.ruleForm['quality'] = 1
            }else {
                this.ruleForm['quality'] = 2
            }
        },
        // 图片点击事件
        imgclick(e, key) {
            this.ruleForm[key] = e
            if(key !== 'cover_type') return
            if(e!=0) {
                this.ruleForm['cover'] = '1'
                if(e==2) {
                    this.cover.splice(2, 1);
                }else {
                    this.cover[2] = 
                        {
                            name: '皮纹纸颜色为封面',
                            id:'2'
                        }
                    
                }
            }
        },
        // 加减事件
        addISj(e) {
            if(e<=0) return
            if(e=="+") {
                this.ruleForm.number = parseInt(this.ruleForm.number)+1
            }else {
                this.ruleForm.number = this.ruleForm.number-1
            }
        },
        // 字典表查询, 补充无需装订
        async query() {
            var res = await this.Api.querys(0)
            this.option = res.data.data
            // delete this.option.size.A3; // 暂时不需要A3
            this.option.binding_type['无需装订'] = 0
            this.button = this.option.cover_color
            this.option.cover_type['无需封面'] = 0
        },
        // 弹窗取消
        cancel() {
            this.$emit("cancel")
        },
        // 弹窗打开事件, 防止修改父组件数据
        open() {
            this.ruleForm = JSON.parse(JSON.stringify(this.oneData))
        },
        // 弹窗编辑确定事件
        confirm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$emit("confirm", this.ruleForm)
                } else {
                    return false;
                }
            });
        }
    },
}
</script>

<style lang='less' scoped>
    /deep/.el-select {
        width: 70%;
    }
    /deep/.el-form-item {
        margin-bottom: 20px;
    }
    .image {
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 36px;
        margin-bottom: 36px;
        div {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 14px;
        }
        img {
            width: 87px;
            height: 85px;
            cursor: pointer;
            transition: .3s;
            max-width: 100%;
            border-radius: 4px;
	        border: solid 1px #eeeeee;
            padding: 2px;
        }
    }
    img.type-img-box {
        transform: scale(1.1);
        transition: .2s;
        border: 1px solid #126eac;
    }
    .overspread {
        width: 28px;
        height: 28px;
        position: absolute;
        top: 12px;
        left: 37%;
        z-index: 1000;
    }
    .copies {
        margin-top: 20px;
        .add {
            position: absolute;
            right: 16px;
            top: -2px;
            .el-button {
                font-size: 18px;
                font-weight: bold;
                color: #888;
            }
        }
    }
    /deep/.el-form-item__error {
        top: 100%;
    }
    .radios {
        display: flex;
        justify-content: space-around;
        width: 80%;
        /deep/.el-radio {
            margin-right: 0;
        }
        /deep/.el-radio__label {
            padding-left: 0;
        }
        div {
            text-align: left;
        }
    }
    .information /deep/ .el-dialog{
      min-width: 460px;
    }
    /deep/ .el-dialog__title{
        font-size: 18px;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        white-space: nowrap;
        width: 81%;
        height: 60px;
        line-height: 60px;
        margin-left: 25px;
    }
    /deep/.el-dialog__header {
        border-bottom: 1px solid #d9d9d9;
        padding: 0;
    }
    /deep/.el-form-item__content {
        margin-left: 120px !important;
    }
    /deep/.el-dialog__body {
        height: 600px;
        overflow: auto;
    }
    .coverImg {
       /deep/.el-upload-dragger {
            width: 80px;
            height: 80px;
            line-height: 72px;
            font-size: 32px;
       } 
       b {
           position: absolute;
            top: -7px;
            right: -7px;
            font-size: 19px;
       }
       position: relative;
       /deep/.el-upload-dragger {
           overflow:inherit;
       }
    }
    .coverBox {
        margin-top: 20px;
        display: flex;
        .coverImg2 {
            margin-left: 10px;
            margin-top: 10px;
            p {
                margin: 0;
                height: 30px;
            }
        }
        .coverImg3 {
            margin-left: 10px;
        }
    }
    .del {
        display: flex;
        justify-content: center;
        flex-direction: column;
        width: 80px;
        height: 80px;
        position: relative;
        margin-left: 10px;
        border: 1px solid #ccc;
        padding: 5px;
        img {
            width: 100%;
            height: 100%;
        }
        div {
            display: none;
            position: absolute;
            left: 0;
            top: 0;
            background-color: rgba(182, 182, 182, 0.7);
            width: 100%;
            height: 100%;
            i {
                font-size: 16px;
                color: #000;
                position: absolute;
                top: 42%;
                left: 42%;
            }
        }
    }
    .del:hover div {
        display: block;
        i {
            color: #409EFF;
        }
    }
    .copies /deep/.el-form-item__content {
        width: 260px;
    }
    @media (max-width: 1564px){
        .radios{
            width: 100%;
        }
        .image span {
            overflow:hidden; //超出的文本隐藏
            text-overflow:ellipsis; //溢出用省略号显示
            white-space:nowrap; //溢出不换行
        }
        .coverBox {
            line-height: 17px;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/information.vue